import { FetchResult, FetchService } from './fetch-service';

export interface PushNotificationRequest {
  userId?: string;
  expoPushToken: string;
  title: string;
  body: string;
}

export class NotificationService {
  private fetchService: FetchService<PushNotificationRequest>;
  private static instance: NotificationService | null = null;

  private constructor() {
    this.fetchService = new FetchService();
  }

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }

    return NotificationService.instance;
  }

  public async send(request: PushNotificationRequest): Promise<string | null> {
    const res: FetchResult<string> = await this.fetchService.update('notifications/send', request);
    if (res.success) {
      return res.data;
    }
    if (res.error) {
      throw new Error(res.error);
    }
    return null;
  }
}
